import secureFetch from 'shared/lib/secure-fetch';
import { checkStatus } from 'shared/lib/http-errors';
import checkResponseBodyCode from 'shared/lib/response-errors';

export function login(identity, password) {
  return fetch('/api/employee/login', {
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      identity,
      password,
    }),
    method: 'POST',
  }).then((response) => {
    checkStatus(response);
    return response.json();
  }).then((json) => checkResponseBodyCode(json));
}

export function sendResetEmail(email) {
  return fetch(`/api/employee/reset_password?email=${email}`)
    .then((response) => checkStatus(response));
}

export function updateUser(accessToken, userId, username, roleId) {
  return secureFetch(`employee/${userId}`, accessToken, {
    body: JSON.stringify({
      username,
      roleId,
    }),
    method: 'PUT',
  });
}

export function setPassword(accessToken, userId, password) {
  return fetch(`/api/employee/set_password/${userId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password }),
    method: 'PUT',
  }).then((response) => {
    checkStatus(response);
    return response.json();
  }).then((json) => checkResponseBodyCode(json));
}

export function refreshToken(accessToken) {
  // This route must match the refresh token cookie path.
  return fetch('/api/employee/refresh_token', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).then((response) => {
    checkStatus(response);
    return response.json();
  }).then((body) => (
    checkResponseBodyCode(body)
  ));
}

export function logout(accessToken, userId) {
  return secureFetch(`employee/${userId}/logout`, accessToken);
}

// Same as routeCheck but components can call this if they need to do additional checks.
export function checkPermissions(checks) {
  return {
    path: 'routecheck',
    body: JSON.stringify(checks),
    method: 'POST',
  };
}

export function isManagerOf(managerId, employeeId) {
  return {
    path: 'user_group_employee/is_manager_of',
    method: 'POST',
    body: JSON.stringify({
      manager_id: managerId,
      employee_id: employeeId,
    }),
  };
}

// Parses an access token and returns the user claims.
export function getClaims(jwt) {
  if (!jwt) return null;
  const payload = jwt.split('.')[1];
  if (!payload) {
    throw new Error('access token is missing payload');
  }

  const claims = JSON.parse(atob(payload));
  if (!claims) throw Error('unable to read access token claims');

  return {
    exp: claims.exp * 1000, // JavaScript dates use milliseconds.
    id: parseInt(claims.sub, 10),
    status: claims.status,
    username: claims.username,
    email: claims.email,
    role: claims.role,
  };
}

// Tenant OnboardAccount Credential
export function deleteOnboardCredentials(onboardAccountId) {
  return {
    path: `tenants/${onboardAccountId}`,
    method: 'DELETE',
  };
}
